import React from 'react';
import { ReactTyped } from 'react-typed';
import { Link } from 'react-scroll';
import SocialLinks from './data/social';
import { site } from './data/site';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';

const Header = () => {
  const reduced = usePrefersReducedMotion();
  const stack = site.typed.join(', ');

  return (
    <header className="hero" aria-label="Introduction">
      <div className="hero-grid" aria-hidden="true"></div>
      <div className="container hero-inner" id="home">
        <div className="row g-4 align-items-center">
          <div className="col-12 col-lg-7">
            <h1 className="hero-name">{site.name}</h1>
            <p className="hero-role">{site.role}</p>
            <div className="hero-actions">
              <Link
                to="contact"
                href="#contact"
                smooth={!reduced}
                offset={-64}
                duration={120}
                className="btn-main-offer"
              >
                {site.cta}
              </Link>
              <SocialLinks className="social-links hero-social" />
            </div>
          </div>
          <div className="col-12 col-lg-5">
            <div className="pane">
              <div className="pane-strip">
                <span>profile</span>
              </div>
              <dl className="kv hero-specs">
                {site.specs.map(({ key, value }) => (
                  <div className="kv-row" key={key}>
                    <dt>{key}</dt>
                    <dd>{value}</dd>
                  </div>
                ))}
                <div className="kv-row">
                  <dt>stack</dt>
                  <dd>
                    <span className="visually-hidden">{stack}</span>
                    <span aria-hidden="true">
                      {reduced ? (
                        stack
                      ) : (
                        <ReactTyped
                          className="typed-text"
                          strings={site.typed}
                          typeSpeed={40}
                          backSpeed={60}
                          loop
                        />
                      )}
                    </span>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
